import { buildSlice, CommonState } from '~libs/reduxUtils';

import { getAll, getOne, typePrefix } from '~lookups/actions/statementStatuses';

import { StatementStatus } from '../models';

const initialState: CommonState<StatementStatus> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  row: undefined,
};

const slice = buildSlice<CommonState<StatementStatus>, StatementStatus>(typePrefix, initialState, {
  commonConfig: { getAll, getOne },
});

export const { clear, updateParams } = slice.actions;
export default slice.reducer;
